const Shell = () => (
  <div className="new-container">
    <div className="cart">
      <div className="cart-header shell-loader"></div>
      <div className="cart-main">
        <div className="cart-sections">
          <div className="cart-postal-code shell-loader"></div>
          <div>
            <div className="cart-section shell-loader"></div>
            <div className="cart-section-big shell-loader"></div>
          </div>
        </div>
        <div className="cart-summary shell-loader"></div>
      </div>
    </div>
  </div>
)

export default Shell
